// extracted by mini-css-extract-plugin
export default {"label":"ConnectionPermissionLinkModal_label__b+nBK","action":"ConnectionPermissionLinkModal_action__z31j0","tag":"ConnectionPermissionLinkModal_tag__xsLgt"};